import _ from "lodash";
import { useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useAddAssetUpdater = () => {
    const [message, setMessage] = useState("");
    const [waitAddAssetUpdater, setWaitAddAssetUpdater] = useState(false);
    // const [tokenAddress, setTokenAddress] = useAtom(tokenContractAddress);
    const tokenAddress = localStorage.getItem("tokenContractAddress");
    const callAddAssetUpdater = async (
        signer: ethers.ContractRunner | null | undefined,
        address: string
    ) => {
        try {
            setWaitAddAssetUpdater(true);

            // const callAbi = new ethers.Contract(
            //     process.env.REACT_APP_CONTRACT_ADDRESS || '',
            //     ERC20ABI.abi,
            //     signer
            // );

            const callAbi = new ethers.Contract(
                tokenAddress || '',
                ERC20ABI.abi,
                signer
            );

            const tx = await callAbi.addAssetUpdater(
                address
            );

            setWaitAddAssetUpdater(false);
            return { err: "", tx: tx };
        } catch (err: any) {
            const errs = _.get(err, "error.message");
            const msgs = _.get("", errs);
            if (err.code === "ACTION_REJECTED") {
                setWaitAddAssetUpdater(false);
                setMessage("User rejected transaction");
                return { err: "User rejected transaction", tx: "" };
            } else {
                if (msgs === undefined) {
                    setWaitAddAssetUpdater(false);
                    setMessage(err.message.split("(")[0] || "");
                    return { err: err.message.split("(")[0] || "", tx: "" };
                } else {
                    setWaitAddAssetUpdater(false);
                    setMessage(msgs.msg);
                    return { err: msgs.msg, tx: "" };
                }
            }
        }
    };

    return {
        onAddAssetUpdater: callAddAssetUpdater,
        waitAddAssetUpdater: waitAddAssetUpdater,
        messageError: message,
    };
};
